import List from './List';
import Details from './Details';

const Cases = {
  List,
  Details
}

export default Cases;